const Domains = [
  { key: 'pm', label: 'PM' },
  { key: 'ee', label: 'EE' },
  { key: 'me', label: 'ME' },
  { key: 'assembly', label: 'Assembly' },
  { key: 'qc', label: 'QC' },
  { key: 'scm', label: 'SCM' },
  { key: 'logistics', label: 'Logistcs' },
  { key: 'warehouse', label: 'Warehouse' }
]

export default Domains
